import { observer, useTranslation, Trans } from "../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
import * as AnalyticsContext from "../analytics/AnalyticsProvider.jsx";
import * as React from "react";
import * as SiteState from "../state/siteStore.js";
import * as AnnouncementModule from "../config/announcement.js";
import { module32314 as d } from "../vendor/dependencies.js";
let AnnouncementBanner = observer(() => {
  let { t: translate } = useTranslation(),
    { track: track } = (0, AnalyticsContext.useAnalytics)(),
    [i, o] = (0, React.useState)(false),
    a = (0, React.useRef)(null),
    r = (0, React.useRef)(null);
  if (
    ((0, React.useLayoutEffect)(() => {
      let e = () => {
        if (!a.current || !r.current) return;
        let e = a.current.clientWidth - 48;
        o(r.current.scrollWidth > e);
      };
      e();
      let t = new ResizeObserver(e);
      return (
        a.current && t.observe(a.current),
        r.current && t.observe(r.current),
        () => t.disconnect()
      );
    }, []),
    !SiteState.siteStore.showBanner)
  )
    return <div />;
  let l = (
    <Trans
      i18nKey={"nav.banner.text"}
      components={{
        a: (
          <a
            href={AnnouncementModule.announcementUrl}
            target={"_blank"}
            rel={"noopener noreferrer"}
            className={"underline text-white"}
            onClick={() => track("track", "global_marquee_click")}
          />
        ),
      }}
    />
  );
  return (
    <div
      id={"banner"}
      ref={a}
      className={
        "bg-[#000000] text-white flex items-center justify-center relative w-full h-[40px] overflow-hidden banner_wrapper__XHu87"
      }
    >
      <div
        className={`flex gap-2 items-center min-w-max ${i ? "banner_bannerScroll__XHu87" : ""}`}
      >
        {i ? (
          ["a", "b", "c", "d", "e", "f"].map((e) => (
            <span
              key={`banner-${e}`}
              className={"text-[13px]/[22px] text-center text-nowrap flex-none"}
            >
              {l}
            </span>
          ))
        ) : (
          <span
            ref={r}
            className={"text-[13px]/[22px] text-center text-nowrap flex-none"}
          >
            {l}
          </span>
        )}
      </div>
      <div
        className={
          "absolute right-0 pl-2 pr-4 top-1/2 -translate-y-1/2 bg-[#000000]"
        }
      >
        <button
          type={"button"}
          onClick={() => {
            SiteState.siteStore.setShowBanner(false);
          }}
          className={
            "flex items-center justify-center w-[16px] h-[16px] cursor-pointer hover:opacity-70 transition-opacity z-10"
          }
          aria-label={translate("nav.banner.close")}
        >
          <d.A
            style={{
              fontSize: "14px",
              color: "#FFFFFF",
            }}
          />
        </button>
      </div>
    </div>
  );
});
export { AnnouncementBanner };
